/**
 * Маппинг имён полей на структуру CRM-payload'а.
 *
 * По конвенции (без атрибута `crm` на поле):
 *   email, phone, name, comment → fields.<name>
 *   любое другое имя             → extra_fields.<name>
 *
 * С атрибутом `crm="custom:slug"` поле всегда летит в extra_fields.<slug>,
 * независимо от своего `name`.
 */

export const STANDARD_FIELDS = new Set(['email', 'phone', 'name', 'comment']);

export interface FieldEntry {
  name: string;
  value: string | string[];
  crm?: string;
}

export interface CrmFields {
  fields: Record<string, string | string[]>;
  extra_fields: Record<string, string | string[]>;
}

export function mapFieldsToCrm(entries: FieldEntry[]): CrmFields {
  const fields: Record<string, string | string[]> = {};
  const extra: Record<string, string | string[]> = {};

  for (const entry of entries) {
    if (entry.crm) {
      const m = /^custom:(.+)$/.exec(entry.crm);
      if (m) {
        extra[m[1]] = entry.value;
        continue;
      }
    }
    if (STANDARD_FIELDS.has(entry.name)) {
      fields[entry.name] = entry.value;
    } else {
      extra[entry.name] = entry.value;
    }
  }

  return { fields, extra_fields: extra };
}
